<template>
<div>
  <div class="content">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-checkbox-group v-model="yuyueList" @change = "OnChange" >
          <div v-for="(item,index) in list" :key="index">
            <div class="appointment-item">
              <van-checkbox :name="item.billno+','+item.outport" @click="showKysj(item.billno,item.outport)" >
                <div class="">
                  <div class="appointment-title">
                    <span class="bill-num">单号:{{item.billno}}</span>
                  </div>
                  <div class="appointment-card">
                    <div class="receivecorp">提货单位:{{item.receivecorp}}</div>
                    <div class="goods-name">品名:{{item.goodsname}}</div>
                    <div class="khtdh">客户提单号:{{item.ownerbillno}}</div>
                    <div class="validdate">有效日期:{{item.validdate}} 00:00</div>
                    <!-- <div class="limitquantity">重量:{{item.limitquantity}}T</div> -->
                    <div class="limitquantity" v-show="item.quantity?true:false">重量:{{item.quantity}}T</div>
                    <div class="limitquantity" v-show="!item.quantity?true:false">预约数量:{{yuzuoyesl}}T</div>
                    <div class="outport">发货站台:{{item.outport}}</div>
                  </div>
                  <div class="kysj-box" v-show="item.isShowKysj">
                    <span class="kysj-content">可用的时间段:{{item.kysj}}</span>
                  </div>
                  </div>
              </van-checkbox>
            </div>
          </div>
          <!--  -->
        </van-checkbox-group>

      </van-list>
    </van-pull-refresh>
  </div>


  <van-popup v-model="showPicker" round position="bottom">
    <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" :loading="loading" />
  </van-popup>

  <div class="add-yuyue">
    <van-button round block type="info" @click="yuyueGoods" class="addBtn" color="#316892">
      预约
    </van-button>
  </div>
  <Tabbar></Tabbar>
</div>
</template>
<script>
import Tabbar from '../Public/tabbarTpl.vue'
import api from '@/fetch/api'
export default {
  components: {
    Tabbar
  },
  data() {
    return {
      yuzuoyesl:0,
      yyrq:"",
      yuyueList: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      vehicleState: "01",
      billnoList: [],
      outportList: [],
      tihuoList: [],
      showPicker: false,
      showField: false,
      columns: [],
      value: '',
      xyState: "00",
      quantity:0,
      billnoOutportList:[],
      checkboxNameBillNo:"",
      checkboxNameOutport:"",
    }
  },
  created: function() {
    document.title = "提货预约";
    //this.gettxhtzdnew();
    var yuzuoyesl = this.$route.params.number;
    var yyrq = this.$route.params.yyrq;
    this.yuzuoyesl = yuzuoyesl;
    this.yyrq = yyrq;
    if(this.yyrq == "")
    {
      this.$router.push({
        name: 'appointment',
        params: {
          number: this.inputYyNumber,
        }
      })
    }

    var list =  [
        {
            "receiptdescription": "卸货",
            "totalv3": null,
            "outport": "6308",
            "billmemo": "",
            "validdate": "2024-03-30",
            "density": null,
            "receivecorp": "江阴晶泰芯国际贸易有限公司",
            "ownerbillno": "3344222",
            "groupid": 0,
            "shiptype": "Truck",
            "isciq": 1,
            "location": "2304",
            "state": 1,
            "islimit": 1,
            "receiptowner": "2791",
            "factquantity": 0.000,
            "isstop": 0,
            "stopbeforqty": 0.000,
            "limitquantity": 0.0,
            "msgdate": "2024-03-04 16:02:37",
            "isblack": 0,
            "isred": 0,
            "isoriginalarrive": 0,
            "goodsname": "苯乙烯",
            "ship": "浙JB1593",
            "addship": "浙JC875",
            "createdate": "2024-03-04 16:02:37",
            "ownername": "240304江阴晶泰芯国际贸易有限公司集港(001)",
            "isret": 0,
            "isreturn": 0,
            "ownerid": null,
            "planquantity": 300.000,
            "goodsid": "0401",
            "quantity": 0.000,
            "billno": "CXHP20240304001",
            "contractno": "LTSH23A030(004)",
            "creator": "管理员",
            "yyrq": "2024-03-05"
        }
    ];
    this.list = list;
  },
  methods:{
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        this.gettxhtzdnew();

        this.loading = false;
        this.finished = true;
      }, 1000);
    },
    //预约选择
    OnChange(value) {
      var billnoOutportList = JSON.stringify(value);
      this.$data.billnoOutportList = JSON.parse(billnoOutportList);
      console.log('value',billnoOutportList);
    },
    isItemChecked(itemId) {
      // 判断某个特定的复选框是否被选中
      return this.billnoOutportList.includes(itemId);
    },
    onConfirm(value) {
      this.showPicker = false;
      var billno = this.checkboxNameBillNo;
      var outport = this.checkboxNameOutport;
      var checkedInfo = this.isItemChecked(billno+','+outport);
      var list = this.list;
      if(list.length>0)
      {
        list.forEach((item,index) => {
          if(item.billno == billno && item.outport == outport)
          {
            item.isShowKysj = checkedInfo;
            item.kysj = value.text;
          }
          this.list.splice(index, 1, item);
        })
      }
    },
    yuyueGoods()
    {
      console.log('yuyueGoods');
    },
    //展示可用时间
    showKysj(billno,outport)
    {
      var checkedInfo = this.isItemChecked(billno+','+outport);
      if(checkedInfo == true)
      {
        this.checkboxNameBillNo = billno;
        this.checkboxNameOutport = outport;
        this.getpdxxnew(outport);
      }
      else{
        this.checkboxNameBillNo = "";
        this.checkboxNameOutport = "";
        var list = this.list;
        if(list.length>0)
        {
          list.forEach((item,index) => {
            if(item.billno == billno && item.outport == outport)
            {
              item.isShowKysj = false;
              item.kysj = "";
            }
            this.list.splice(index, 1, item);
          })
        }
      }
    },
    gettxhtzdnew()
    {
      // var yyrq = this.yyrq;
      // var openid = this.$store.state.wx_info.openid;
      // var txhlb = "提货";
      // var postData = {
      //   yyrq:yyrq,
      //   txhlb:txhlb,
      //   openid:openid
      // };
      //
      // var that = this;
      // api.gettxhtzdnew(postData).then(function(resData) {
      //   var res = JSON.parse(resData);
      //   if(res.respCode == 0)
      //   {
      //     that.yuyueList = res.data;
      //   }
      // });

      var list =  [
          {
              "receiptdescription": "卸货",
              "totalv3": null,
              "outport": "6308",
              "billmemo": "",
              "validdate": "2024-03-30",
              "density": null,
              "receivecorp": "江阴晶泰芯国际贸易有限公司",
              "ownerbillno": "3344222",
              "groupid": 0,
              "shiptype": "Truck",
              "isciq": 1,
              "location": "2304",
              "state": 1,
              "islimit": 1,
              "receiptowner": "2791",
              "factquantity": 0.000,
              "isstop": 0,
              "stopbeforqty": 0.000,
              "limitquantity": 0.0,
              "msgdate": "2024-03-04 16:02:37",
              "isblack": 0,
              "isred": 0,
              "isoriginalarrive": 0,
              "goodsname": "苯乙烯",
              "ship": "浙JB1593",
              "addship": "浙JC875",
              "createdate": "2024-03-04 16:02:37",
              "ownername": "240304江阴晶泰芯国际贸易有限公司集港(001)",
              "isret": 0,
              "isreturn": 0,
              "ownerid": null,
              "planquantity": 300.000,
              "goodsid": "0401",
              "quantity": 0.000,
              "billno": "CXHP20240304001",
              "contractno": "LTSH23A030(004)",
              "creator": "管理员",
              "yyrq": "2024-03-05"
          },
          {
              "receiptdescription": "卸货",
              "totalv3": null,
              "outport": "63081",
              "billmemo": "",
              "validdate": "2024-03-30",
              "density": null,
              "receivecorp": "江阴晶泰芯国际贸易有限公司",
              "ownerbillno": "3344222",
              "groupid": 0,
              "shiptype": "Truck",
              "isciq": 1,
              "location": "2304",
              "state": 1,
              "islimit": 1,
              "receiptowner": "2791",
              "factquantity": 0.000,
              "isstop": 0,
              "stopbeforqty": 0.000,
              "limitquantity": 0.0,
              "msgdate": "2024-03-04 16:02:37",
              "isblack": 0,
              "isred": 0,
              "isoriginalarrive": 0,
              "goodsname": "苯乙烯",
              "ship": "浙JB1593",
              "addship": "浙JC875",
              "createdate": "2024-03-04 16:02:37",
              "ownername": "240304江阴晶泰芯国际贸易有限公司集港(001)",
              "isret": 0,
              "isreturn": 0,
              "ownerid": null,
              "planquantity": 300.000,
              "goodsid": "0401",
              "quantity": 0.000,
              "billno": "CXHP20240304001",
              "contractno": "LTSH23A030(004)",
              "creator": "管理员",
              "yyrq": "2024-03-05"
          }
      ];
      this.list = list;

    },
    getpdxxnew(thk)
    {
      var yyrq = this.yyrq;
      var postData = {
        thk:thk,
        yyrq:yyrq
      };

      var that = this;
      api.getpdxxnew(postData).then(function(resData) {
        var res = JSON.parse(resData);
        if(res.respCode == 0)
        {
          that.showField = true;
          that.showPicker = true;
          that.columns = res.data;
        }
      });

      that.showField = true;
      that.showPicker = true;

      var columns = [
        {
            "id": "4028d9818e0e393f018e0e3d5bcc0009",
            "yiyonghs": 0,
            "bpmStatus": "2",
            "pinzhong": "苯乙烯",
            "pdrq": "2024-03-05",
            "thk": "11-3",
            "thkid": "40288a167490686801749154f6a9007a",
            "haoshu": 1,
            "sfyy": "N",
            "shengyuhs": 1,
            "pdsj": "20时45分-21时00分",
            "sfkt": "Y"
        },
        {
            "id": "4028d9818e0e393f018e0e3ca7870003",
            "yiyonghs": 0,
            "bpmStatus": "2",
            "pinzhong": "苯乙烯",
            "pdrq": "2024-03-05",
            "thk": "12-3",
            "thkid": "40288a1674a6c9d80174a9f486090019",
            "haoshu": 1,
            "sfyy": "N",
            "shengyuhs": 1,
            "pdsj": "20时45分-21时00分",
            "sfkt": "Y"
        },
        {
            "id": "4028d9818e0e393f018e0e3d64e7000b",
            "yiyonghs": 0,
            "bpmStatus": "2",
            "pinzhong": "苯乙烯",
            "pdrq": "2024-03-05",
            "thk": "11-3",
            "thkid": "40288a167490686801749154f6a9007a",
            "haoshu": 1,
            "sfyy": "N",
            "shengyuhs": 1,
            "pdsj": "21时30分-21时45分",
            "sfkt": "Y"
        },
        {
            "id": "4028d9818e0e393f018e0e3cb26c0005",
            "yiyonghs": 0,
            "bpmStatus": "2",
            "pinzhong": "苯乙烯",
            "pdrq": "2024-03-05",
            "thk": "12-3",
            "thkid": "40288a1674a6c9d80174a9f486090019",
            "haoshu": 1,
            "sfyy": "N",
            "shengyuhs": 1,
            "pdsj": "21时30分-21时45分",
            "sfkt": "Y"
        }
    ];

    that.columns = columns.map(item => {
        return { text:"台位"+item.thk + "  时间"+ item.pdsj, value: item.id };
      });

    },
  },

}
</script>


<style lang="scss" scoped>
body,
html {
    overflow-x: hidden;
}

.content {
    margin-top: 1rem;
    .appointment-item {
        background: #ffffff;
        border-radius: 5px;
        position: relative;
        background: #ffffff;
        margin: 0 1rem;
        padding: 1rem 0.875rem;
        color: #101010;
        font-size: 0.875rem;
        line-height: 2;
        margin-bottom: 1rem;
        .receivecorp {
            font-weight: bold;
            color: #3eb4fa;
        }
        .goods-name {
            font-weight: bold;
            color: #3eb4fa;
        }
        .kysj-content{
          color: #ed6a0c;
        }
    }
}

.add-yuyue {
    position: fixed;
    bottom: 3.75rem;
    left: 0.5rem;
    right: 0.5rem;
    line-height: 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
}
</style>
